// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AnalyticsOrganisationItemModel from '../../model/analytics-organisation-item-model';
import AnalyticsOrganisationItemDTO from '../dto/analytics-organisation-item-dto';
import dtoSchema from '../schemas/analytics-organisation-item-schema';
import AnalyticsItemModel from '../../model/analytics-item-model';

export default abstract class AnalyticsOrganisationItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AnalyticsOrganisationItemDTO>) {
    super();
    if (data) {
      this.companyId = data.companyId ?? undefined;
      this.companyName = data.companyName ?? undefined;
      this.analytics = data.analytics ? AnalyticsItemModel.toModel(data.analytics) : undefined;
    }
  }
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  */
  companyName?: string;
  /**
  */
  analytics?: AnalyticsItemModel;

  static toModel(dto: DeepPartial<AnalyticsOrganisationItemDTO>): AnalyticsOrganisationItemModel;
  static toModel(dto: DeepPartial<AnalyticsOrganisationItemDTO> | undefined | null): AnalyticsOrganisationItemModel | undefined;
  static toModel(dto: DeepPartial<AnalyticsOrganisationItemDTO> | undefined | null): AnalyticsOrganisationItemModel | undefined {
    return dto ? new AnalyticsOrganisationItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AnalyticsOrganisationItemModel> | AnalyticsOrganisationItemModel): AnalyticsOrganisationItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      companyId: unwrapped.companyId,
      companyName: unwrapped.companyName,
      analytics: unwrapped.analytics,
    } as AnalyticsOrganisationItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AnalyticsOrganisationItemModel, can not map to AnalyticsOrganisationItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
